import get from 'lodash/get';
import { HEADER_HEIGHT } from 'utils/constants';
import { LINK_TYPE } from 'utils/constants/linkType';
import { getDocumentFields } from 'utils/helper';

export default ({
  section,
  type,
  handleOnCTAClick: handleOnCTAClickCommon,
}) => {
  const {
    title,
    description,
    subtitle,
    view,
    contentModules,
  } = getDocumentFields(
    section,
    [
      'title',
      'description',
      'subtitle',
      'view',
      'contentModules',
    ],
  );
  const { text: tableContent } = getDocumentFields(get(contentModules, '[0]', []), ['text']);
  const ctaLink = get(contentModules, '[1]');

  const handleOnCTAClick = (e) => {
    if (ctaLink?.fields?.type === LINK_TYPE.scrollToSection) {
      e.preventDefault();

      const element = document.getElementById(ctaLink.fields.url);

      window.scrollBy({
        top: element.getBoundingClientRect().top - HEADER_HEIGHT - 50,
        behavior: 'smooth',
      });
    } else if (handleOnCTAClickCommon) {
      handleOnCTAClickCommon();
    }
  };

  const ctaLinkData = ctaLink?.fields?.type === LINK_TYPE.scrollToSection ? {
    ...ctaLink,
    fields: {
      ...ctaLink.fields,
      url: '',
    },
  } : ctaLink;

  return {
    title,
    description,
    subtitle,
    view,
    type,
    tableContent,
    ctaLinkData,
    ctaLink: ctaLinkData,
    handleOnCTAClick,
  };
};
